import { Heart, ShieldCheck, MessageCircle, Sparkles } from "lucide-react";

const pillars = [
  {
    icon: Heart,
    title: "Comfort first",
    body: "Your pet's routine, comfort zones, and quirks come first. Always.",
  },
  {
    icon: ShieldCheck,
    title: "Trust & safety",
    body: "Locally owned, fully present, and committed to keeping pets and homes secure.",
  },
  {
    icon: MessageCircle,
    title: "Daily updates",
    body: "Photos, videos, and notes on every visit — so you can relax wherever you are.",
  },
  {
    icon: Sparkles,
    title: "Free meet & greet",
    body: "We meet before booking so every pet (and parent) feels at ease.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-28 bg-[#FFFBF0] border-y-2 border-[#3F2A56]/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 grid lg:grid-cols-[1fr_1.15fr] gap-14 items-center">
        <div className="relative">
          <div className="grid grid-cols-2 gap-4">
            <div className="rounded-3xl overflow-hidden border-2 border-[#3F2A56]/15 aspect-[3/4] -rotate-2">
              <img
                src="https://customer-assets.emergentagent.com/job_happy-tails-aurora/artifacts/bfziq4kx_FB_IMG_1746828750129.jpg"
                alt="A sleepy pup curled up on a yellow velvet pillow under a sage blanket"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="rounded-3xl overflow-hidden border-2 border-[#3F2A56]/15 aspect-[3/4] rotate-2 mt-10">
              <img
                src="https://customer-assets.emergentagent.com/job_happy-tails-aurora/artifacts/q1pt0e9z_Snapchat-1837480879.jpg"
                alt="A dog napping nose-to-nose with two cats in the late afternoon sun"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-[#3F2A56] text-[#F4E8C8] rounded-full px-5 py-3 shadow-lg rotate-[-2deg]">
            <span className="font-script text-2xl">building trust, one tail wag at a time</span>
          </div>
        </div>

        <div>
          <span className="font-script text-2xl text-[#b85b7e]">hi, I&rsquo;m Aurora</span>
          <h2 className="font-display font-bold text-4xl sm:text-5xl text-[#3F2A56] mt-2 leading-tight">
            Pet care that feels like family.
          </h2>
          <p className="mt-5 text-[#5C4A73] text-lg leading-relaxed">
            Happy Tails by Aurora is a small, locally-owned pet care service in
            the Byron-Bergen area. Whether your pup needs an adventure walk or
            your cats need someone trustworthy while you travel, I show up with
            patience, kindness, and treats.
          </p>
          <p className="mt-3 text-[#5C4A73] text-lg leading-relaxed">
            My promise: <strong className="text-[#3F2A56]">your pet&rsquo;s comfort is the top priority</strong> —
            from their favorite walking route to which corner of the couch is theirs.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            {pillars.map((p) => (
              <div
                key={p.title}
                data-testid={`pillar-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex gap-4 p-5 rounded-2xl bg-[#F4E8C8]/50 border border-[#3F2A56]/15 hover:-translate-y-0.5 transition-transform"
              >
                <div className="w-11 h-11 rounded-full bg-[#3F2A56] text-[#F4E8C8] grid place-items-center shrink-0">
                  <p.icon className="w-5 h-5" />
                </div>
                <div>
                  <h4 className="font-display text-lg font-semibold text-[#3F2A56]">
                    {p.title}
                  </h4>
                  <p className="text-sm text-[#5C4A73] mt-0.5 leading-relaxed">
                    {p.body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
